import { apiInstance } from "shared/api";
import { PayoutResponse, PayoutBody } from "./types";

export const payout = (
  id: string,
  body?: PayoutBody,
): Promise<PayoutResponse> => {
  return apiInstance
    .post(`/v1/payout/${id}`, body)
    .then((response) => response.data);
};
